import { IconDefinition } from "./types";

/**
 * Note: This icon uses the name "cross" but renders an X mark (close icon).
 * FontAwesome's faCross is a religious cross symbol.
 * Consider migrating to `xmark` (the FA icon) in a future release.
 */
const cross: IconDefinition = {
  iconName: "cross",
  width: 640,
  height: 640,
  svgPathData:
    "M182.9 137.4L160.3 114.7L115 160L137.6 182.6L275 320L137.6 457.4L115 480L160.3 525.3L182.9 502.6L320.3 365.3L457.6 502.6L480.3 525.3L525.5 480L502.9 457.4L365.5 320L502.9 182.6L525.5 160L480.3 114.7L457.6 137.4L320.3 274.7L182.9 137.4z",
  iconType: "fill",
  unicode: 0xe005,
};

export { cross };
